module.exports = __webpack_public_path__ + "img/section5-item1.832f5248.svg";